import { CMSApiResponse }       from "framework/http/CMSApiClient";
import { RunContextApp }        from "framework/RCApp";
import { QA_WORKFLOW }          from "types/cms/frontendTypes";
import { CreateSurveyQuestionRequestData, 
         GetQuestionBank, 
         UpdateQuestions 
       }                        from "types/apis/surveyInterfaces";
import { APIData }              from "types/cms/frontendTypes";

export const SurveyQBApis = {

  createQuestion : async (rc : RunContextApp,
                           utilityDocumentId : string,
                           question : CreateSurveyQuestionRequestData) : Promise<CMSApiResponse<any>> => {

    const resp = await rc.cmsApiClient.post<any>('/survey/createQuestion', {
      utilityDocumentId : utilityDocumentId,
      data : question
    })

    return resp
  },

  getQuestionBank : async (rc : RunContextApp,
                           utilityDocumentId : string) : Promise<CMSApiResponse<GetQuestionBank.retval>> => {

    const resp = await rc.cmsApiClient.get<GetQuestionBank.retval>(
      `${GetQuestionBank.apiEndpoint}?utilityDocumentId=${utilityDocumentId}`)
    return resp
  },

  updateQuestions : async (rc : RunContextApp,
                           params : UpdateQuestions.params) : Promise<CMSApiResponse<UpdateQuestions.retval>> => {

    const resp = await rc.cmsApiClient.post<UpdateQuestions.retval>(UpdateQuestions.apiEndpoint, params)
    return resp
  },

  discardDraftQuestions : async (rc : RunContextApp, 
                                 pilotId : string, 
                                 questionDocIds : string[]) : Promise<CMSApiResponse<string[]>> => {

    const resp = await rc.cmsApiClient.post<string[]>(`/survey/discardAllDrafts`, {
      pilotId : pilotId,
      data : questionDocIds
    })
    return resp
  },

  publishQuestions : async (rc : RunContextApp, 
                            utilityDocumentId : string, 
                            questionDocIds : string[]) : Promise<CMSApiResponse<APIData<'api::survey-question.survey-question'>[]>> => {

    const resp = await rc.cmsApiClient.post<APIData<'api::survey-question.survey-question'>[]>(`/survey/publishAll`, {
      utilityDocumentId : utilityDocumentId,
      data : questionDocIds
    })
    return resp
  },

  unpublishQuestions : async (rc : RunContextApp, 
                              utilityDocumentId : string, 
                              questionDocIds : string[]) : Promise<CMSApiResponse<APIData<'api::survey-question.survey-question'>[]>> => {

    const resp = await rc.cmsApiClient.post<APIData<'api::survey-question.survey-question'>[]>(`/survey/unpublishAll`, {
      utilityDocumentId : utilityDocumentId,
      data : questionDocIds
    })
    return resp
  },

  getReviewWorkflow : async (rc : RunContextApp) : Promise<CMSApiResponse<QA_WORKFLOW>> => {
    const resp = await rc.cmsApiClient.get<QA_WORKFLOW>('/survey/getReviewWorkflow')
    return resp
  }

}